export { default as App } from './App';
export { default as Login } from './Login';
export { default as DashboardView } from './DashboardView';
export { default as NavBar } from './NavBar';
export { default as ProfileView } from './ProfileView';
export { default as AdminProfile } from './AdminProfile';
export { default as SampleComponent } from './SampleComponent';
export { default as AdminDashboard } from './AdminDashboard';
export { default as AdminCreateAccount } from './AdminCreateAccount';
export { default as AdminActivateAccount } from './AdminActivateAccount';
export { default as AdminViewUpdateLog } from './AdminViewUpdateLog';
export { default as DirectorProfile } from './DirectorProfile';
export { default as RegistrarProfile } from './RegistrarProfile';
export { default as TeacherProfile } from './TeacherProfile';
export { default as StudentProfile } from './StudentProfile';
export { default as ParentProfile } from './ParentProfile';
export { default as DirectorDashboard } from './DirectorDashboard';
export { default as RegistrarDashboard } from './RegistrarDashboard';
export { default as TeacherDashboard } from './TeacherDashboard';
export { default as StudentDashboard } from './StudentDashboard';
export { default as ParentDashboard } from './ParentDashboard';
export { default as RegistrarListSections } from './RegistrarListSections';
export { default as RegistrarSectionsListView } from './RegistrarSectionsListView';
export { default as Page404 } from './Page404';
export { default as Page401 } from './Page401';
export { default as RegistrarSectionsList } from './RegistrarSectionsList';
export { default as RegistrarManageStudentsView } from './RegistrarManageStudentsView';
export { default as RegistrarManageStudents } from './RegistrarManageStudents';
export { default as RegistrarViewEnrolled } from './RegistrarViewEnrolled';
export { default as RegistrarViewEnrolledView } from './RegistrarViewEnrolledView';
export { default as StudentTooltip } from './StudentTooltip';
export { default as RegistrarViewPastRecordsView } from './RegistrarViewPastRecordsView';
export { default as RegistrarViewPastRecords } from './RegistrarViewPastRecords';
export { default as RegistrarAssignAdvisorySectionView } from './RegistrarAssignAdvisorySectionView';
export { default as RegistrarAssignAdvisorySection } from './RegistrarAssignAdvisorySection';
export { default as RegistrarAssignSubjectLoadView } from './RegistrarAssignSubjectLoadView';
export { default as RegistrarAssignSubjectLoad } from './RegistrarAssignSubjectLoad';
export { default as RegistrarViewSubjectLoadView } from './RegistrarViewSubjectLoadView';
export { default as RegistrarViewSubjectLoad } from './RegistrarViewSubjectLoad';
export { default as RegistrarAddNewLoad } from './RegistrarAddNewLoad';
export { default as RegistrarEditSubjectLoadView } from './RegistrarEditSubjectLoadView';
export { default as RegistrarEditSubjectLoad } from './RegistrarEditSubjectLoad';
export { default as TeacherViewSubjectLoadView } from './TeacherViewSubjectLoadView';
export { default as TeacherViewSubjectLoad } from './TeacherViewSubjectLoad';
export { default as TeacherViewSubjectLoadByIdView } from './TeacherViewSubjectLoadByIdView';
export { default as TeacherViewSubjectLoadById } from './TeacherViewSubjectLoadById';
export { default as TeacherManageGradesView } from './TeacherManageGradesView';
export { default as TeacherManageGrades } from './TeacherManageGrades';
export { default as TeacherComponentView } from './TeacherComponentView';
export { default as TeacherComponent } from './TeacherComponent';
export { default as TeacherSubcomponentView } from './TeacherSubcomponentView';
export { default as TeacherSubcomponent } from './TeacherSubcomponent';
export { default as TeacherAddRecordView } from './TeacherAddRecordView';
export { default as TeacherAddRecord } from './TeacherAddRecord';
export { default as TeacherSummaryPerQuarterView } from './TeacherSummaryPerQuarterView';
export { default as TeacherSummaryPerQuarter } from './TeacherSummaryPerQuarter';
export { default as TeacherEditRecordView } from './TeacherEditRecordView';
export { default as TeacherEditRecord } from './TeacherEditRecord';
export { default as TeacherSummaryView } from './TeacherSummaryView';
export { default as TeacherSummary } from './TeacherSummary';
export { default as RegistrarSetSubmissionDeadline } from './RegistrarSetSubmissionDeadline';
export { default as SchoolYearInfo } from './SchoolYearInfo';
export { default as RegistrarViewUpdateLog } from './RegistrarViewUpdateLog';
export { default as ViewEditLog } from './ViewEditLog';
export { default as RegistrarIndividualDeliberationView } from './RegistrarIndividualDeliberationView';
export { default as RegistrarIndividualDeliberation } from './RegistrarIndividualDeliberation';
export { default as RegistrarGroupDeliberationView } from './RegistrarGroupDeliberationView';
export { default as RegistrarGroupDeliberation } from './RegistrarGroupDeliberation';
export { default as RegistrarIndividualDeliberationInfoView } from './RegistrarIndividualDeliberationInfoView';
export { default as RegistrarIndividualDeliberationInfo } from './RegistrarIndividualDeliberationInfo';
export { default as ClassRecordInformation } from './ClassRecordInformation';
export { default as RegistrarManageGradesView } from './RegistrarManageGradesView';
export { default as RegistrarManageGrades } from './RegistrarManageGrades';
export { default as RegistrarComponentView } from './RegistrarComponentView';
export { default as RegistrarComponent } from './RegistrarComponent';
export { default as RegistrarSubcomponentView } from './RegistrarSubcomponentView';
export { default as RegistrarSubcomponent } from './RegistrarSubcomponent';
export { default as RegistrarEditRecordView } from './RegistrarEditRecordView';
export { default as RegistrarEditRecord } from './RegistrarEditRecord';
export { default as RegistrarAddRecordView } from './RegistrarAddRecordView';
export { default as RegistrarAddRecord } from './RegistrarAddRecord';
export { default as RegistrarSummaryReportView } from './RegistrarSummaryReportView';
export { default as RegistrarSummaryReport } from './RegistrarSummaryReport';
export { default as RegistrarGroupDeliberationInfoView } from './RegistrarGroupDeliberationInfoView';
export { default as RegistrarGroupDeliberationInfo } from './RegistrarGroupDeliberationInfo';
export { default as RegistrarViewStudentRecordView } from './RegistrarViewStudentRecordView';
export { default as RegistrarViewStudentRecord } from './RegistrarViewStudentRecord';
export { default as RegistrarViewStudentRecordTeacherView } from './RegistrarViewStudentRecordTeacherView';
export { default as RegistrarViewStudentRecordTeacher } from './RegistrarViewStudentRecordTeacher';
export { default as RegistrarViewStudentRecordStudentView } from './RegistrarViewStudentRecordStudentView';
export { default as RegistrarViewStudentRecordStudent } from './RegistrarViewStudentRecordStudent';
export { default as RegistrarViewStudentRecordSectionView } from './RegistrarViewStudentRecordSectionView';
export { default as RegistrarViewStudentRecordSection } from './RegistrarViewStudentRecordSection';
export { default as RegistrarViewStudentRecordGradeView } from './RegistrarViewStudentRecordGradeView';
export { default as RegistrarViewStudentRecordGradeCompView } from './RegistrarViewStudentRecordGradeCompView';
export { default as RegistrarViewStudentRecordGradeSubcompView } from './RegistrarViewStudentRecordGradeSubcompView';
export { default as RegistrarViewStudentRecordGradeSummaryReportView } from './RegistrarViewStudentRecordGradeSummaryReportView';
export { default as AllStudentDeliberationGrades } from './AllStudentDeliberationGrades';
export { default as AllStudentFinalGrades } from './AllStudentFinalGrades';
export { default as CashierDashboard } from './CashierDashboard';
export { default as RestrictAccount } from './RestrictAccount';
export { default as CashierProfile } from './CashierProfile';
export { default as ViewHonorStudents } from './ViewHonorStudents';
export { default as ViewFailedStudents } from './ViewFailedStudents';
export { default as StudentViewGrade } from './StudentViewGrade';
export { default as TeacherAdviseeGrade } from './TeacherAdviseeGrade';



// WEBPACK FOOTER //
// ./src/features/app/index.js